import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Page } from "../../model/Paginacao/Page";
import { Comarca } from "../../model/comarca";
import { Lotacao } from "../../model/lotacao";
import { ServidorRecad } from "../../model/servidorRecad";
import { DadosPessoaisPosRecadDto } from "../../components/pos-recadastramento/aba1-posrecad/dadosPessoaisPosRecad.dto";
import { ArquivoBlobDTO } from 'app/model/arquivoBlob.dto';
import { DependentePosRecadDto } from "../../components/pos-recadastramento/aba2-posrecad/dependentePosRecad.dto";


@Injectable()
export class PosCampanhaService extends GenericService {

    private baseUrl = environment.url + 'api/v1';

    constructor(http: HttpClient) {
        super(http);
    }

    getComarca(): Observable<Comarca[]> {
        return this.http.get<Comarca[]>(this.baseUrl + "/comarca");
    }

    getLotacao(comarcaId: number, pagina: number, valorLotacao: string): Observable<Page<Lotacao>> {
        return this.http.get<Page<Lotacao>>(`${this.baseUrl}/localizacao/comarca/${comarcaId}/lotacao/${valorLotacao}/pagina/${pagina}/tamanho/10`);
    }

    verificarConcessaoRecadastramento(param): Observable<any> {
        return this.getMethod<any>(`api/v1/admin/validacao-recadastramento/abas-disponiveis`, { recadValidacaoId: param });
    }

    getRecadastramentos(param): Observable<Page<ServidorRecad>> {
        return this.getMethod<Page<ServidorRecad>>(`api/v1/admin/validacao-recadastramento/filtro`, param);
    }

    getDadosPessoais(param): Observable<DadosPessoaisPosRecadDto> {
        return this.getMethod<DadosPessoaisPosRecadDto>(`api/v1/admin/validacao-recadastramento/dados-pessoais`, { validacaoRecadId: param });
    }

    postDadosPessoais(body): Observable<any> {
        return this.postMethod<any>(body, `api/v1/admin/validacao-recadastramento/dados-pessoais`);
    }

    visualizarAnexo(idServidor: number, comprovante: string): Observable<any> {
        const params = new HttpParams().set('recadServidorId', idServidor.toString());

        // Defina responseType como 'blob' para obter uma resposta binária
        const options = {
          responseType: 'blob' as 'json'
        };
        console.log(options)
        return this.http.get<ArquivoBlobDTO>(this.url + `api/v1/admin/validacao-recadastramento/anexo/${comprovante}`, {
            params,
            ...options })
    }

    getDependentes(param): Observable<DependentePosRecadDto[]> {
        return this.getMethod<DependentePosRecadDto[]>(`api/v1/admin/validacao-recadastramento/dependente`, { recadValidacaoId: param });
    }

    visualizarAnexosDependetes(idServidor: number, comprovante: string): Observable<any> {
        const params = new HttpParams().set('recadValidacaoDependentesId', idServidor.toString());

        // Defina responseType como 'blob' para obter uma resposta binária
        const options = {
            responseType: 'blob' as 'json'
        };
        console.log(options)
        return this.http.get<ArquivoBlobDTO>(this.url + `api/v1/admin/validacao-recadastramento/dependente/${comprovante}`, {
            params,
            ...options })
    }

    postDependente(body): Observable<any> {
        return this.postMethod<any>(body, `api/v1/admin/validacao-recadastramento/dependente`);
    }

    getServidores(nomeServidor: string, ano: string): Observable<Page<any>> {
        return this.getMethod<Page<any>>(`api/v1/admin/validacao-recadastramento/lista-servidores-finalizados?nomeServidor=${nomeServidor}&pagina=0&tamanhoPagina=10&ano=${ano}`);
    }
}
